<template>
    <div class="c-reset-password">
        <BackButton />

        <h1>{{$t('reset_pass.title')}}</h1>

        <div class="form">
            <div class="form--row anim">
                <div class="form--row--label">{{$t('generic.email')}}</div>
                <input type="email" class="inputfield" :class="{error : emailError}" v-model="email" autocomplete="off"/>
            </div>
            <div class="form--row anim">
                <div class="form--row--label"></div>
                <button class="btn-basic blue" @click.prevent="submit" :disabled="loading">{{$t('reset_pass.btn')}}</button>
            </div>
            <div class="form--row" v-if="feedback">
                <div class="form--row--label"></div>
                <div class="form--success">{{$t('reset_pass.reset_ok')}}</div>
            </div>
            <div class="form--row" v-if="userError">
                <div class="form--row--label"></div>
                <div class="form--error">{{$t('reset_pass.user_error')}}</div>
            </div>
            <div class="form--row" v-if="serverError">
                <div class="form--row--label"></div>
                <div class="form--error">{{$t('generic.server_error')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import {apiStore} from "@/stores/api";
import {isValidEmail} from "@/utils/utils.js";

export default {
    name : "ResetPass",
    components: {
        BackButton
    },
    data() {
        return {
            email: "",
            emailError : false,
            loading : false,
            userError : false,
            serverError : false,
            feedback : false
        };
    },

    methods: {
        async submit() {
            this.emailError = false;
            this.userError = false;
            this.feedback = false;
            this.serverError = false;

            if (!isValidEmail(this.email)) {
                this.emailError = true;
            }
            if (!this.emailError && !this.passwordError) {
                this.loading = true;
                const response = await apiStore().forgotPassword(this.email);
                this.loading = false;
                console.log(response);
                if (response === "password_sent") {
                    this.feedback = true;

                } else if (response === "user_not_found") {
                    this.userError = true;

                } else {
                    this.serverError = true;
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-reset-password {
        text-align: center;

        h1 {
            margin-top : 10vh;
        }

        .form {
            margin : 6vh auto;
            width : 50vw;

            .inputfield {
                width : 65%;
            }

            &--row {
                display: flex;
                &.anim {
                    @for $i from 1 through 5 {
                        &:nth-child(#{$i}) {
                            @include slideIntroAnimation(basicSlideIntro, 750ms, #{350ms + $i * 350ms});
                        }
                    }
                }

                &--label {
                    padding-top: 1rem;
                    font-size: 1.5em;
                    width: 30%;
                    text-align: right;
                    margin-right: 5%;

                }
            }

            &--error {
                font-size: 1.25em;
                margin-top : 2rem;
                color : $color-red;
                text-align: left;
                width: 100%;
            }

            &--success {
                font-size: 1.25em;
                margin-top : 2rem;
                color : $color-green;
            }
        }
    }
</style>